import * as React from 'react';

const SvgOutreachBounced = (props) => (
  <svg
    width={42}
    height={42}
    viewBox="0 0 42 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g filter="url(#filter0_d_967_3962)">
      <circle cx={21} cy={18} r={12} fill="#F74343" />
    </g>
    <path
      d="M22.76 12.9733L16.74 14.9733C12.6934 16.3266 12.6934 18.5333 16.74 19.88L18.5267 20.4733L19.12 22.26C20.4667 26.3066 22.68 26.3066 24.0267 22.26L26.0333 16.2466C26.9267 13.5466 25.46 12.0733 22.76 12.9733ZM22.9733 16.56L20.44 19.1066C20.34 19.2066 20.2134 19.2533 20.0867 19.2533C19.96 19.2533 19.8334 19.2066 19.7334 19.1066C19.54 18.9133 19.54 18.5933 19.7334 18.4L22.2667 15.8533C22.46 15.66 22.78 15.66 22.9733 15.8533C23.1667 16.0466 23.1667 16.3666 22.9733 16.56Z"
      fill="white"
    />
    <circle cx={23} cy={23} r={4} fill="#F74343" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M25.4816 24.6862C25.8088 24.2057 26 23.6252 26 23C26 21.3431 24.6569 20 23 20C22.3748 20 21.7943 20.1912 21.3138 20.5184L25.4816 24.6862ZM24.6861 25.4817C24.2056 25.8088 23.6251 26 23 26C21.3431 26 20 24.6569 20 23C20 22.3749 20.1912 21.7944 20.5183 21.3139L24.6861 25.4817Z"
      fill="white"
    />
    <defs>
      <filter
        id="filter0_d_967_3962"
        x={0}
        y={0}
        width={42}
        height={42}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology
          radius={1}
          operator="dilate"
          in="SourceAlpha"
          result="effect1_dropShadow_967_3962"
        />
        <feOffset dy={3} />
        <feGaussianBlur stdDeviation={4} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_967_3962"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_967_3962"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export default SvgOutreachBounced;
